// Write-only secrets in forms (contract: responses carry has_<field>; in a PUT an
// omitted secret keeps the stored value and "" clears it).

export type SecretEdit =
  /** Leave the stored value alone (field omitted from the request). */
  | { mode: 'keep' }
  /** Send this value; an empty value is the same as keep. */
  | { mode: 'set'; value: string }
  /** Send "" - the stored value is removed. */
  | { mode: 'clear' }

/** Initial edit state: nothing stored yet -> an empty input to type into. */
export function initialSecret(has: boolean): SecretEdit {
  return has ? { mode: 'keep' } : { mode: 'set', value: '' }
}

/** The request field: undefined = omit (keep), "" = clear, otherwise the new value. */
export function secretRequest(edit: SecretEdit): string | undefined {
  if (edit.mode === 'clear') return ''
  if (edit.mode === 'set' && edit.value !== '') return edit.value
  return undefined
}

/** Whether a secret will be present after the request is applied. */
export function secretPresent(has: boolean, edit: SecretEdit): boolean {
  if (edit.mode === 'clear') return false
  if (edit.mode === 'set' && edit.value !== '') return true
  return has
}

/** The value about to be sent, or null; for client-side length checks. */
export function secretNewValue(edit: SecretEdit): string | null {
  return edit.mode === 'set' && edit.value !== '' ? edit.value : null
}
